import { render, staticRenderFns } from "./ContentTags.vue?vue&type=template&id=4760510e&scoped=true&"
import script from "./ContentTags.vue?vue&type=script&lang=js&"
export * from "./ContentTags.vue?vue&type=script&lang=js&"
import style0 from "./ContentTags.vue?vue&type=style&index=0&id=4760510e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4760510e",
  null
  
)

export default component.exports